import { MessageCircle } from "lucide-react";
import { whatsappLink } from "../data/site";
import { useLang } from "../context/LanguageContext";

// Persistent floating WhatsApp "Call Now" button (bottom-right on every page).
export function WhatsAppFloat() {
  const { t } = useLang();
  return (
    <a
      href={whatsappLink(t.wa.general)}
      target="_blank"
      rel="noreferrer"
      data-testid="whatsapp-float-button"
      aria-label="Chat on WhatsApp"
      className="fixed bottom-6 right-6 z-[60] flex items-center gap-2.5 bg-[#25D366] hover:bg-[#1da851] text-white font-heading font-bold text-base sm:text-lg py-4 px-5 sm:px-7 rounded-full shadow-2xl transition-all hover:scale-105 active:scale-95 group"
    >
      <span className="relative flex h-7 w-7 items-center justify-center">
        <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-white/40 opacity-75" />
        <MessageCircle size={28} className="relative" />
      </span>
      <span className="hidden sm:inline">{t.common.callNow}</span>
    </a>
  );
}

export default WhatsAppFloat;
